import { PlanSubmitBlockReason } from '@ebalance/proto/bffuser/v1/procurement_plan_model_pb'

/**
 * 提出を止める理由 (AC-PLC-055 / 056 / 062) ごとの画面の扱い。 ヘッダーの「提出」(`DetailHeader`) と
 * 誘導メッセージ (`resolveSubmitGuidance`) が同じ表を引く。
 */
export type BlockReasonView = {
  /** 誘導メッセージの本文。 `submitButton: 'disabled'` の時は提出ボタンの押せない理由の文にも使う。 */
  messageKey: string
  /**
   * ヘッダーの「提出」 の扱い (AC-PLC-062)。
   * - `hidden`: 描画しない (この版は提出できる状態に戻らない)
   * - `disabled`: 非活性にし、 `messageKey` を押せない理由として画面上に文で出す
   */
  submitButton: 'hidden' | 'disabled'
  /**
   * `latestPlanSubmissionId` が無い時に誘導メッセージへ置く動作 (id がある時は「最新の計画を開く」)。
   * 'recreate' は作成失敗と同じ「計画を作り直す」 (AC-PLC-056 上記以外)。
   */
  fallbackAction?: 'recreate'
}

/**
 * 理由の値ごとの表。 proto に値が足されると型エラーになり、 ここで扱いを決める。
 */
const BLOCK_REASON_VIEWS: Record<
  PlanSubmitBlockReason,
  BlockReasonView | undefined
> = {
  [PlanSubmitBlockReason.UNSPECIFIED]: undefined,
  [PlanSubmitBlockReason.SUPERSEDED_VERSION]: {
    messageKey: 'page:procurementPlanDetail.submitGuidance.supersededVersion',
    submitButton: 'hidden',
  },
  // AC-PLC-056 / 062: 未提出で行を欠き、 同じ業務ワークフロー内の同じ計画に新しい版がある。 案内先は
  // その最新の版 (backend が latestPlanSubmissionId で返す)。
  [PlanSubmitBlockReason.NEW_VERSION_CREATED]: {
    messageKey: 'page:procurementPlanDetail.submitGuidance.newVersionCreated',
    submitButton: 'hidden',
  },
  [PlanSubmitBlockReason.MISSING_BASELINE_BOXES]: {
    messageKey:
      'page:procurementPlanDetail.submitGuidance.missingBaselineBoxes',
    submitButton: 'disabled',
    fallbackAction: 'recreate',
  },
}

/**
 * 理由の扱いを返す。 理由なし (UNSPECIFIED) と、 この build が知らない値 (backend が先に
 * 値を足した時) は undefined。 呼び出し側は未知の値を「提出を描画しない」 側に倒す。
 */
export function blockReasonView(
  reason: PlanSubmitBlockReason,
): BlockReasonView | undefined {
  return BLOCK_REASON_VIEWS[reason]
}
